import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import NavigationMenu from '../Navigation/NavigationMenu';
import Header from './Header';
import { usePageTitle } from '../../hooks/usePageTitle';
import '../../css/components/Layout.css';

const Layout: React.FC = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const pageTitle = usePageTitle();

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  return (
    <div className="layout">
      <div className={`sidebar ${isSidebarCollapsed ? 'collapsed' : ''}`}>
        <NavigationMenu isCollapsed={isSidebarCollapsed} />
      </div>
      
      <div className={`main-content ${isSidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
        <Header onToggleSidebar={toggleSidebar} title={pageTitle} />
        
        <main className="content">
          <div className="content-wrapper">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;
